"use strict";

var moduleName = "ngDro-utils-notify";
angular.module(moduleName, ['ngDro']);
global.ngDroModules.push(moduleName);

//angular.module(moduleName).config(require('./configs/StateProvider'));

angular.module(moduleName).config(require('./configs/TranslateProvider'));

//ngDroControllers

//ngDroDirectives


angular.module(moduleName).factory('ngDroHandlerLanguage', require('./services/HandlerLanguage'));
angular.module(moduleName).factory('ngDroUtilsNotify', require('./services/notify/Notify'));
angular.module(moduleName).factory('ngDroUtilsDeregisterListner', require('./services/notify/DeregisterListner'));

angular.module(moduleName).run(['MainViews', function (MainViews) {

//MainViews.register({
//    title: 'Page',
//    state: 'state',
//    iconClass: 'fa fa-fw fa-icon',
//    order: 0
//});

}]);


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/module.js
// module id = 433
// module chunks = 0